import { alpha, Card, styled, Typography } from "@mui/material";
import { SxProps } from "@mui/system";
import { StyleguideSavioColors } from "../../../configuration/themeSettings";
import CircleButtonBig from "../../AppButtons/CircleButtonBig";

export const classes = {
    content: {
        padding: 0,
        position: "relative",
    } as SxProps,

    complexCardIcon: {
        top: "-3px",
        left: "20px",
        position: "absolute",
    } as SxProps,
    replacements: {
        top: 5,
        right: 5,
        position: "absolute",
        color: StyleguideSavioColors.blue,
        "svg": {
            fontSize: 24,
        }
    } as SxProps,

    basketCardButton: {
        top: "-3px",
        right: "10px",
        position: "absolute",
    } as SxProps,


};

export const MediaDiv = styled("div", { label: "card-media-div" })(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    marginTop: 5,
    marginBottom: 5,
    height: 190,

    "> img":{

        "&:not([src$='.svg'])":{
            
            padding: 10,

        }

    }
})
);

export const MediaImg = styled("img", { label: "card-media-img" })(({ theme }) => ({
    height: "200px",
    width: "200px",
    objectFit: "contain",
})
);

export const Code = styled(Typography, { label: "card-code" })(({ theme }) => ({
    textTransform: "uppercase",
    fontSize: 12,
    textAlign: 'left',
    color:StyleguideSavioColors.text.black,
})
);

export const CardRoot = styled(Card, { label: "card-root" })(({ theme }) => ({

    display: "flex",
    flexDirection: "column",
    marginLeft: 18,
    marginRight: 18,
    marginTop: "5px",
    marginBottom: 30,
    position: "relative",
    height: 254,
    width: 198,
    cursor: "pointer",
    boxShadow: "0px 3px 6px 0px " + alpha(theme.palette.common.black, 0.2),
    overflow: "visible",

    ".MuiCardContent-root": {
        padding: 0,
        paddingLeft: 10,
        paddingRight: 40,
        position: 'relative',
        width: "100%",
        "&:last-child":{
            paddingBottom:0,
        },

        
    },
    "&:hover": {
        backgroundColor: "rgba(230, 75, 0, 0.04)",
        transition: "all 0.5s ease-in-out",
        'h6 + div p':{
            color: StyleguideSavioColors.blue,
        }
    },

})
);

export const Name = styled(Typography, { label: "card-name" })(({ theme }) => ({
    textAlign: 'left',
    fontSize: 12,
    color: StyleguideSavioColors.mainBlue,
    lineHeight: '14px',
    display: "-webkit-box",
    margin: "0 auto",
    overflow: "hidden",
    textOverflow: "ellipsis",
    height: 29,
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
})
);


export const ButtonAddCart = styled(CircleButtonBig, { label: "home-site_icon_button" })
    (({ theme }) => ({
        position: "absolute",
        right: -15,
        bottom: -15,
        width: 48,
        height: "48px !important",
        border: '1px solid ' + theme.palette.primary.main,
        "svg": {
            fontSize: 24,
            position: 'relative',
            top: "auto",
            right: 'auto',
        }
    }))